import { render, staticRenderFns } from "./VisualizarFaqDialog.vue?vue&type=template&id=384fca7e"
import script from "./VisualizarFaqDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarFaqDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports